<template>
  <md-field class="select-field">
    <label class="label" for="vertical">{{label}}</label>
    <md-select class="select-input" :name="name" :id="id" v-model="content" @input="handleInput">
      <slot />
    </md-select>
  </md-field>
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    name: String,
    value: {
      required: true,
    },
    id: String,
    label: String,
    type: {
      type: String,
      default: 'text',
    },
    required: String,
    labelBg: {
      type: String,
      default: '#330e2f',
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
};
</script>

<style lang="scss">
.md-field.md-theme-default.md-highlight .md-input {
  -webkit-text-fill-color: unset !important;
  color: #fff !important;
}

.select-input {
  border: 1px solid #fff;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 8px;

  .md-input {
    -webkit-text-fill-color: unset !important;
    color: #fff;
  }
  .md-icon.md-theme-default.md-icon-image svg {
    fill: #fff;
  }
}
</style>

<style scoped lang="scss">
.md-field.select-field {
  margin: 4px 0 3px;
  padding-top: 30px;

  &:before {
    display: none;
  }

  &:after {
    display: none;
  }

  &.md-focused,
  &.md-has-value {
    label.label {
      top: 0px;
      left: -5px;
    }

    .input .md-input {
      color: #979797;
      -webkit-text-fill-color: unset;
    }
  }

  &.md-focused {
    .input .md-input {
      border: 1px solid #fff;
      transition: 0.3s ease all;
      color: #fff;
      -webkit-text-fill-color: unset;
    }

    label.label {
      color: #fff;
    }
  }

  .input .md-input {
    border: 1px solid #d8d8d8;
    border-radius: 5px;
    height: 54px;
    font-size: 16px;
    color: #fff;
    -webkit-text-fill-color: unset;
    transition: 0.3s ease all;
    padding: 0 15px;
  }

  label.label {
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    color: #fff;
    top: 33px;
    left: 20px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
